export default {
    list: {
        en: "Inglese",
        it: "Italiano",
        ru: "Russo",
        es: "Spagnolo",
    },
}
